export const reactRouterFutureFlags = {
  v7_relativeSplatPath: true,
  v7_startTransition: true,
};
